import { api } from "@api/api";
import { CloneAgreementInput, CloneAgreementResponse } from "./types";

export async function cloneAgreementService({
  id,
  name,
  slug_map,
}: CloneAgreementInput): Promise<CloneAgreementResponse> {
  const { data } = await api.post<CloneAgreementResponse>(
    `v1/agreement_admin/${id}/clone/`,
    { name, slug_map }
  );

  return data;
}
